import Component from '@glimmer/component';

export interface Args {
	colspan?: number;
}

export default class DummyCellComponent extends Component<Args> {
	get colspan() {
		// eventually we can remove this
		// when all dummy-cells use visible-check-container modifier
		return this.args.colspan || 1;
	}
	<template>
		<td class="dummy-cell" colspan={{this.colspan}}>
			<div class="skeleton-cell">
				<span class="skeleton-shape skeleton-shape--avatar"></span>
				<span class="skeleton-stack">
					<span class="skeleton-shape skeleton-shape--title"></span>
					<span class="skeleton-shape skeleton-shape--subtitle"></span>
				</span>
			</div>
		</td>
	</template>
}
